// extracted by mini-css-extract-plugin
module.exports = {"root":"cursor-module--root--2ewJ9","icon":"cursor-module--icon--2E6c_","text":"cursor-module--text--33fK7","rotate":"cursor-module--rotate--3i8b-"};